module.exports = __webpack_public_path__ + "img/Footerlogo.ce17833e.svg";